import { __extends } from "tslib";
import { GetPushTemplateRequest, GetPushTemplateResponse } from "../models/models_1";
import { deserializeAws_restJson1GetPushTemplateCommand, serializeAws_restJson1GetPushTemplateCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var GetPushTemplateCommand = /** @class */ (function (_super) {
    __extends(GetPushTemplateCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetPushTemplateCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    GetPushTemplateCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "PinpointClient";
        var commandName = "GetPushTemplateCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: GetPushTemplateRequest.filterSensitiveLog,
            outputFilterSensitiveLog: GetPushTemplateResponse.filterSensitiveLog,
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetPushTemplateCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1GetPushTemplateCommand(input, context);
    };
    GetPushTemplateCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1GetPushTemplateCommand(output, context);
    };
    return GetPushTemplateCommand;
}($Command));
export { GetPushTemplateCommand };
//# sourceMappingURL=GetPushTemplateCommand.js.map